import React, { useEffect, useRef } from 'react';
import { FormField, FormFieldLabel, FormFieldValue } from 'styles/common.styles';

/**
 * Number ?�???�드 컴포?�트
 * 
 * ?�자 ?�력???�한 ?�용 컴포?�트?�니??
 * 
 * @param {Object} props
 * @param {string} props.name - ?�드 ?�름
 * @param {string} props.label - ?�드 ?�벨
 * @param {string|number} props.value - ?�드 �? * @param {string} props.width - ?�드 ?�비
 * @param {string} props.flex - flex ?�성
 * @param {string} props.labelWidth - ?�벨 ?�비
 * @param {string} props.fieldWidth - FormField ?�체 ?�비
 * @param {boolean} props.readonly - ?�기 ?�용 ?��?
 * @param {boolean} props.hasError - ?�러 ?�태
 * @param {number} props.min - 최소�? * @param {number} props.max - 최�?�? * @param {number} props.step - 증�?/감소 ?�위 (기본�? 1)
 * @param {string} props.roundMode - 반올�?모드: 'round' (반올�? 기본�?, 'floor' (버림), 'ceil' (?�림)
 * @param {Function} props.onChange - �?변�??�들?? * @param {Function} props.onKeyDown - ???�운 ?�들?? * @param {Function} props.onKeyUp - ?????�들?? * @param {Object} props.fieldProps - 추�? ?�드 ?�성
 */
const NumberField = ({
  name,
  label,
  value = '',
  width,
  flex,
  labelWidth,
  fieldWidth,
  showColon = false,
  readonly = false,
  min,
  max,
  step = 1,
  roundMode = 'round', // 'round' (반올�?, 'floor' (버림), 'ceil' (?�림)
  onChange,
  onKeyDown,
  onKeyUp,
  fieldProps = {},
}) => {
  // 천단??콤마 추�? ?�수
  const formatNumberWithComma = (num) => {
    if (num === '' || num === null || num === undefined) return '';
    const numStr = num.toString();
    // ?�수?�이 ?�는 경우?� ?�는 경우 분리
    const parts = numStr.split('.');
    // ?�수 부분에 콤마 추�?
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  };

  // 콤마 ?�거 ?�수
  const removeComma = (str) => {
    if (!str) return '';
    return str.toString().replace(/,/g, '');
  };

  // step?�서 ?�수???�리??계산
  const getDecimalPlaces = (stepValue) => {
    if (!stepValue || stepValue === 1) return 0;
    const stepStr = stepValue.toString();
    if (stepStr.includes('.')) {
      return stepStr.split('.')[1].length;
    }
    if (stepStr.includes('e-')) {
      // 과학???�기�?처리 (?? 1e-2)
      return parseInt(stepStr.split('e-')[1]);
    }
    return 0;
  };

  // step??맞춰 �?조정 ?�수 (roundMode???�라 ?�르�?처리)
  const roundToStep = (value, stepValue, mode = 'round') => {
    if (!stepValue || stepValue === 1) {
      if (mode === 'floor') return Math.floor(value);
      if (mode === 'ceil') return Math.ceil(value);
      return Math.round(value);
    }
    
    // step??배수�?조정
    const rounded = Math.round(value / stepValue) * stepValue;
    const floored = Math.floor(value / stepValue) * stepValue;
    const ceiled = Math.ceil(value / stepValue) * stepValue;
    
    if (mode === 'floor') return floored;
    if (mode === 'ceil') return ceiled;
    return rounded; // 'round' (기본�?
  };

  // min/max 범위 검�?�?조정 ?�들??
  const handleChange = (e) => {
    if (readonly || !onChange) return;
    
    let inputValue = e.target.value;
    
    // 콤마 ?�거
    inputValue = removeComma(inputValue);
    
    // �?값이�?콤마 ?�거??�?문자?�로 ?�달
    if (inputValue === '' || inputValue === null || inputValue === undefined) {
      const emptyEvent = {
        ...e,
        target: {
          ...e.target,
          name: name,
          value: '',
        },
      };
      onChange(emptyEvent);
      return;
    }
    
    // ?�자�?변??
    const numValue = parseFloat(inputValue);
    
    // ?�자가 ?�니�?�?문자?�로 ?�달
    if (isNaN(numValue)) {
      const invalidEvent = {
        ...e,
        target: {
          ...e.target,
          name: name,
          value: '',
        },
      };
      onChange(invalidEvent);
      return;
    }
    
    // step??맞춰 �?조정 (roundMode???�라)
    let adjustedValue = roundToStep(numValue, step, roundMode);
    
    // min/max 범위 검�?�?조정
    if (min !== undefined && min !== null && adjustedValue < min) {
      adjustedValue = min;
    }
    if (max !== undefined && max !== null && adjustedValue > max) {
      adjustedValue = max;
    }
    
    // 콤마�??�거???�자 값으�??�벤???�성 (??�� 콤마 ?�는 ?�자�??�달)
      const decimalPlaces = getDecimalPlaces(step);
    const cleanValue = decimalPlaces > 0 
        ? adjustedValue.toFixed(decimalPlaces)
        : adjustedValue.toString();
      
    const cleanEvent = {
        ...e,
        target: {
          ...e.target,
          name: name,
        value: cleanValue, // 콤마 ?�는 ?�자�??�달
        },
      };
    onChange(cleanEvent);
  };

  // ?�전 �?추적 (무한 루프 방�?)
  const prevValueRef = useRef(value);
  const isInitialMountRef = useRef(true);
  
  // 초기값이???��??�서 값이 ?�정????step??맞춰 ?�동 조정
  useEffect(() => {
    // 초기 마운???�에????�� 체크
    const isInitialMount = isInitialMountRef.current;
    if (isInitialMount) {
      isInitialMountRef.current = false;
    } else {
      // 값이 변경되지 ?�았?�면 ?�킵 (초기 마운?��? ?�닐 ?�만)
      if (prevValueRef.current === value) return;
    }
    
    prevValueRef.current = value;
    
    if (value === '' || value === null || value === undefined) return;
    
    const numValue = parseFloat(value);
    if (isNaN(numValue)) return;
    
    // step??맞춰 조정
    const adjustedValue = roundToStep(numValue, step, roundMode);
    
    // 조정??값이 ?�래 값과 ?�르�??�동?�로 ?�데?�트
    if (Math.abs(adjustedValue - numValue) > 0.0001 && onChange) {
      const decimalPlaces = getDecimalPlaces(step);
      const formattedValue = decimalPlaces > 0 
        ? adjustedValue.toFixed(decimalPlaces)
        : adjustedValue.toString();
      
      const syntheticEvent = {
        target: {
          name: name,
          value: formattedValue,
        },
      };
      // 비동기로 처리?�여 무한 루프 방�?
      setTimeout(() => {
        onChange(syntheticEvent);
      }, 0);
    }
  }, [value, step, roundMode, name, onChange]);

  return (
    <FormField
      flex={flex || '0 0 auto'}
      width={fieldWidth || 'auto'}
    >
      {label && (
        <FormFieldLabel width={labelWidth} >{showColon ? `${label}:` : label}</FormFieldLabel>
      )}
      <FormFieldValue
        name={name}
        type="text" // number ?�?��? 콤마�??�시?????�으므�?text�?변�?        // 0?� falsy?�서 빈값?�로 보일 ???�으므�?null/undefined/''�?빈값 처리
        value={value === '' || value === null || value === undefined ? '' : formatNumberWithComma(value)}
        readOnly={readonly}
        onChange={readonly ? undefined : handleChange}
        onKeyDown={onKeyDown}
        onKeyUp={onKeyUp}
        style={{textAlign: 'right'}}
        width={width || 'auto'}
        inputMode="numeric" // 모바?�에???�자 ?�패???�시
        {...fieldProps}
      />
    </FormField>
  );
};

export default NumberField;

